import { useContext } from 'react'
import useLoanEntities from './useLoanEntities'
import { loanContext } from '../../../shared/LoanContext'

function useDocumentOnwership() {
  const { rid: loanId } = useContext(loanContext)
  const entities = useLoanEntities()

  const getEntityOnwer = (documentId) => {
    const isIncludedInList = (documents) =>
      documents.find((doc) => doc.rid === documentId)

    for (const entity of entities) {
      const { documents, archivedDocuments = [] } = entity

      if (isIncludedInList(documents) || isIncludedInList(archivedDocuments))
        return entity
    }
  }

  return { loanId, getEntityOnwer }
}

export default useDocumentOnwership
